import { api } from '../apis/constants';
import { Category, CategoryFilter, CategoryFormData, CategoryResponse } from '../types/categories';

// Lấy danh sách category
const getCategories = async (filter: CategoryFilter = {}): Promise<CategoryResponse> => {
  try {
    const response = await api.get('/categories/admin/all');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Tạo category mới
const createCategory = async (data: CategoryFormData): Promise<any> => {
  try {
    return await api.post('/categories', data);
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

// Cập nhật category
const updateCategory = async (id: string, data: Partial<Category>): Promise<Category> => {
  try {
    return await api.patch(`/categories/${id}`, data);
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

// Xóa category
const deleteCategory = async (id: string): Promise<void> => {
  try {
    return await api.delete(`/categories/${id}`);
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

const categoryService = {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService;